<template>
  <div class="cn23-item-card">
    <b-row>
      <b-col cols="12" sm="2" md="2">
        <b-form-group :label="$t('Quantity')" label-for="quantity">
          <b-form-input
            class="custom-input"
            id="quantity"
            v-model="item.quantity"
            trim
            type="number"
            min="1"
            number
          ></b-form-input>
        </b-form-group>
      </b-col>
      <b-col cols="12" sm="6" md="6">
        <b-form-group
          :label="`${$t('Detailed description')} *`"
          label-for="detailed-description"
        >
          <b-form-input
            class="custom-input"
            id="detailed-description"
            v-model="item.description"
            :state="
              $v.description.$dirty || hasFormError
                ? !$v.description.$invalid
                : null
            "
            trim
            ref="description"
          ></b-form-input>
        </b-form-group>
      </b-col>
      <b-col cols="12" sm="2" md="2">
        <b-form-group :label="`${$t('Weight')} *`" label-for="weight">
          <b-input-group append="kg">
            <b-form-input
              class="custom-input number-input"
              id="weight"
              v-model="item.weight"
              :state="
                $v.weight.$dirty || hasFormError ? !$v.weight.$invalid : null
              "
              type="number"
              trim
              number
            ></b-form-input>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col cols="12" sm="2" md="2">
        <b-form-group :label="`${$t('Value')} *`" label-for="value">
          <b-input-group prepend="€">
            <b-form-input
              class="custom-input number-input"
              id="value"
              v-model="item.value"
              :state="
                $v.value.$dirty || hasFormError ? !$v.value.$invalid : null
              "
              type="number"
              trim
              number
            ></b-form-input>
          </b-input-group>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="0" sm="2" md="2"></b-col>
      <b-col cols="6" md="4">
        <b-form-group :label="$t('HS Code')" label-for="hs-code">
          <b-form-input
            class="custom-input"
            id="hs-code"
            v-model="item.hsCode"
            trim
          ></b-form-input>
        </b-form-group>
      </b-col>
      <b-col cols="6" sm="2">
        <b-button
          class="hs-code-button"
          variant="outline-primary"
          href="https://www.trade-tariff.service.gov.uk/sections"
          target="_blank"
        >
          <font-awesome-icon icon="search" />
          {{ $t("Find") }}
        </b-button>
      </b-col>
      <b-col cols="12" sm="4" xs="12">
        <b-form-group
          :label="$t('Country of origin')"
          label-for="origin-country"
        >
          <country-select
            class="custom-input"
            v-model="item.originCountry"
            :country="item.originCountry"
            topCountry="US"
            :placeholder="$t('Select country')"
            countryName
            :usei18n="false"
          />
        </b-form-group>
      </b-col>
    </b-row>
    <button
      class="delete-button"
      :aria-label="$t('Delete item')"
      v-if="index > 0"
      @click="deleteItem"
    >
      <font-awesome-icon icon="trash-alt" />
    </button>
    <button class="add-new-button" @click="$emit('add-item')" v-if="isLastItem">
      <font-awesome-icon icon="plus" />
      {{ $t("Add another item") }}
    </button>
  </div>
</template>

<script>
import { BRow, BCol, BFormGroup, BFormInput, BButton } from "bootstrap-vue";

export default {
  name: "CN23ContentItem",
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BButton,
  },
  data() {
    return {
      quantity: null,
      description: null,
      hsCode: null,
      weight: null,
      value: null,
      originCountry: null,
    };
  },
  props: ["index", "item", "isLastItem", "$v", "hasFormError"],
  methods: {
    deleteItem() {
      this.$emit("delete-item");
    },
  },
  mounted() {
    if (this.index !== 0) {
      this.$refs["description"].focus();
    }
  },
};
</script>

<style scoped>
.cn23-item-card {
  max-width: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  margin: 0px 0px 40px 0px;
  background: rgb(251, 251, 251);
  border: 1px solid rgb(241, 241, 241);
  border-radius: 15px;
  line-height: 1em;
  padding: 25px;
}

.delete-button {
  right: -20px;
  top: -23px;
  position: absolute;
  width: 45px;
  min-height: 45px;
  margin: 0px;
  border: 1px solid #f1f1f1;
  color: #122857;
  border-radius: 34px;
  transition: background 0.25s ease-in-out;
  background: white;
  font-size: 18px;
  line-height: 1em;
}

.add-new-button {
  margin: 0px auto;
  margin-bottom: -45px;
  padding: 10px;
  background: rgb(255, 255, 255);
  border: 1px solid rgb(231, 231, 231);
  border-radius: 45px;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
  transition: box-shadow 0.2s ease-in-out, background 0.2s ease-in-out;
  font-weight: 600;
  font-size: 17px;
  line-height: 1em;
  color: #122857;
}

.add-new-button:focus {
  outline: none;
  background: rgba(0, 0, 0, 0.05);
}

.hs-code-button:hover {
  background: rgba(0, 0, 0, 0.05);
  color: #122857;
  border: inherit;
}

@media screen and (max-width: 576px) {
  .delete-button {
    right: 20px;
  }
}
</style>
